// Helpers
import { getGroupColumnDefinition } from "./groupcoldef";
// MUI
import { Stack } from "@mui/material";
// Components
import CommonToolbar from "@/Layouts/components/Tables/DataSmartTable/toolbar/CommonToolbar";
import NoRowsOverlay from "@/Layouts/components/Tables/DataSmartTable/additional/NoRowsOverlay";
import DataSmartTable from "@/Layouts/components/Tables/DataSmartTable";
// MUI
import { GridColDef, useGridApiRef } from "@mui/x-data-grid-premium";
// Types and constants
import { DEFAULT_HEADER_HEIGHT, DEFAULT_ROW_HEIGHT } from "@/Washouts/constants";
import { ProductsSeparatedTableProps } from "@/Washouts/types/finance";
import generateTailwindVariableClasses from "@/Common/helpers/TailwindCSS";

const DATA_SMART_TABLE_HORIZONTAL_SCROLL_GAP_IN_PX = 12; // this is something that might change if the DataSmartTable component changes
const GAP_IN_ROWS_BETWEEN_TABLES = 3;

export function ProductsSeparatedTable(props: Readonly<ProductsSeparatedTableProps>) {
	const title = props.title ?? "Product Conversions";
	const { columns = { chargebacks: [], data: [] }, rows = { chargebacks: [], data: [] } } = props;
	const apiRefChargebacks = useGridApiRef();
	const apiRefData = useGridApiRef();
	const cbData = rows?.chargebacks ?? [];
	const pcData = rows?.data ?? [];
	const gapInRows = props.gapInRowsBetweenSeparatedTables ?? GAP_IN_ROWS_BETWEEN_TABLES;
	const gapInPixels = gapInRows * DEFAULT_ROW_HEIGHT;
	const availableGapSpace = gapInPixels - DATA_SMART_TABLE_HORIZONTAL_SCROLL_GAP_IN_PX - DEFAULT_HEADER_HEIGHT;
	const flexGapY = Math.floor(availableGapSpace / 2);
	const headerGap = availableGapSpace - flexGapY;

	return (
		<Stack
			className="flex flex-col gap-y-[--flex-gap-y]"
			sx={{
				...generateTailwindVariableClasses("--flex-gap-y", `${flexGapY}px`),
			}}
		>
			<DataSmartTable
				enableCustomScrollbars
				maxRows={props.maxSeparatedConversionsTopTableRows}
				enableRowsFiller={false}
				apiRef={apiRefChargebacks}
				columns={(columns?.chargebacks as GridColDef[]) ?? []}
				rows={cbData}
				disableColumnMenu
				disableRowSelectionOnClick
				disableMultipleRowSelection
				checkboxSelection={false}
				columnVisibilityModel={{
					_id: false,
				}}
				slots={{
					toolbar: CommonToolbar,
					noRowsOverlay: NoRowsOverlay,
				}}
				slotProps={{
					toolbar: {
						customTitle: {
							hide: false,
							label: title,
							sx: { mb: "15px" },
						},
					},
					noRowsOverlay: {
						title: `No ${title} Data`,
					},
				}}
				customProps={{}}
			/>

			<DataSmartTable
				enableCustomScrollbars
				maxRows={props.maxSeparatedConversionsBottomTableRows ? props.maxSeparatedConversionsBottomTableRows + 1 : undefined}
				enableRowsFiller={true}
				apiRef={apiRefData}
				columns={(columns?.data as GridColDef[]) ?? []}
				rows={pcData}
				headerHeight={DEFAULT_HEADER_HEIGHT + headerGap}
				disableColumnMenu
				disableRowSelectionOnClick
				disableMultipleRowSelection
				checkboxSelection={false}
				treeData
				getTreeDataPath={(row) => row.hierarchy}
				groupingColDef={getGroupColumnDefinition(false, apiRefData)}
				defaultGroupingExpansionDepth={1}
				columnVisibilityModel={{
					_id: false,
				}}
				initialState={{
					aggregation: {
						model: { penetrationNew: "sum", penetrationUsed: "sum" },
					},
				}}
				slots={{
					noRowsOverlay: NoRowsOverlay,
				}}
				slotProps={{
					noRowsOverlay: {
						title: `No ${title} Data`,
					},
				}}
				customProps={{}}
			/>
		</Stack>
	);
}
